/**
 * @generated SignedSource<<edfeb3cf059095a5b67ac1594bdb9030>>
 * @relayHash 4f65c6189d896574bf6ec36dbe116f12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71241e9e7fc404acd1b23615af90c1197ceefddf71cff1f0587a3d7940e3ecb1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type notificationTabsQuery$variables = {
  cloudId: string;
  isUnsuppressionEnabled: boolean;
  notificationActionType?: string | null | undefined;
  notificationType?: string | null | undefined;
  projectId?: AGG$Long | null | undefined;
};
export type notificationTabsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable">;
};
export type notificationTabsQuery = {
  response: notificationTabsQuery$data;
  variables: notificationTabsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUnsuppressionEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationActionType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "notificationTabsQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "notificationTabsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "AquaOutgoingEmailLogsQueryApi",
        "kind": "LinkedField",
        "name": "aquaOutgoingEmailLogs",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "notificationActionType",
                "variableName": "notificationActionType"
              },
              {
                "kind": "Variable",
                "name": "notificationType",
                "variableName": "notificationType"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              }
            ],
            "kind": "LinkedField",
            "name": "GetNotificationLogs",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v6/*: any*/),
                    "concreteType": "AquaOutgoingEmailLogConnection",
                    "kind": "LinkedField",
                    "name": "logs",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AquaOutgoingEmailLogItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AquaOutgoingEmailLogItem",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AquaIssueContext",
                                "kind": "LinkedField",
                                "name": "issueContext",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "key"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "webUrl"
                                      },
                                      (v7/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "notificationActionType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "actionTimestamp"
                              },
                              {
                                "concreteType": "AquaNotificationDetails",
                                "kind": "LinkedField",
                                "name": "notificationDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "errorKey"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "mailboxMessage"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "recipient",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "condition": "isUnsuppressionEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "email"
                                      }
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      }
                                    ],
                                    "type": "CustomerUser"
                                  },
                                  (v7/*: any*/)
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "startCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasPreviousPage"
                          }
                        ]
                      }
                    ],
                    "storageKey": "logs(first:20)"
                  },
                  {
                    "args": (v6/*: any*/),
                    "handle": "connection",
                    "key": "aquaOutgoingEmail__logs",
                    "kind": "LinkedHandle",
                    "name": "logs"
                  }
                ],
                "type": "AquaOutgoingEmailLog"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "71241e9e7fc404acd1b23615af90c1197ceefddf71cff1f0587a3d7940e3ecb1",
    "metadata": {},
    "name": "notificationTabsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e4deb4a803ece0490b86ed0f2df93fed";

export default node;
